import React from 'react';
import { useInView } from 'react-intersection-observer';

const FadeInSection = (props) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div ref={ref} className={`fade-in-section ${inView ? 'is-visible' : ''}`}>
      {props.children}
    </div>
  );
};

export default FadeInSection;
